var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Section',{attrs:{"width":"md"}},[_c('div',{staticClass:"section-header m-center",domProps:{"innerHTML":_vm._s(_vm.$prismic.asHtml(_vm.slice.primary.h2))}}),_vm._v(" "),_c('div',{staticClass:"list-latest-news width-full flex"},_vm._l((4),function(i){return _c('NewsPost',{key:i})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }